<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7O54zv/images/MyCoverImage.jpg?1703001166742" alt="This image is the cover for the book Corey's Christmas Wish, Pony Tails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Corey's Christmas Wish, Pony Tails
      </h1>
      <p class="bookDescription body article font2">
        <b>Christmas is tough when your parents are divorced, but Corey has a plan to bring </b><b>everyone the merriest Christmas ever</b><br/><br/> With the County Animal Rescue League preparing for its annual Christmas party, the Pony Tails are busy shopping for Christmas presents for all of the animals. But Corey is distracted. It’s the first Christmas since her parents got divorced, and the only present she wants this year is for them to get back together.<br/><br/> To make matters worse, Corey’s mom has been spending a lot of time with Mr. Lee. Corey worries that Mr. Lee will propose, and then there will be no hope of her family reuniting. It may take a Christmas miracle for Corey to be happy this holiday season.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bonnie Bryant
      </h2>
      
      <p class="authorDescription body article">Bonnie Bryant is the author of over one hundred forty books about horses, including the Saddle Club series and its spinoffs, the Pony Tails series and the Pine Hollow series. Bryant did not know very much about horses before writing the first Saddle Club book in 1986, so she found herself learning right along with the characters she created. She has also written novels and movie novelizations under her married name, Bonnie Bryant Hiller. Bryant was born and raised in New York City, where she still lives today.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4fb8c116